import React from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Row, Col } from 'reactstrap';
function LegalDisclaimer({ excludeMarginRoutes = [] }) {
  const location = useLocation();
  const excludeMargin = excludeMarginRoutes.some(r =>
    r instanceof RegExp ? r.test(location.pathname) : location.pathname.startsWith(r)
  );

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{ ...(excludeMargin && { marginLeft: '0px' }) }}
            className="legalDisclaimer border-top text-muted no-print"
          >
            <p>
              At Food Revolution Network (FRN), our mission is healthy, ethical, sustainable food for all. Information
              and resources shared by FRN are for informational purposes only and are not intended to diagnose, treat,
              or cure any type of disease or condition.
            </p>
            <p>
              In support of our educational mission, we sometimes share resources offered by trusted partners. If you
              purchase products from one of these partners, FRN may at times receive a portion of the proceeds. These
              affiliations support our work and allow us to continue bringing you valuable, life-changing content. For
              more information see our{' '}
              <a href="https://foodrevolution.org/privacy-policy/" target="_blank">
                Privacy Policy
              </a>{' '}
              and our{' '}
              <a href="https://foodrevolution.org/terms-and-conditions/" target="_blank">
                Terms of Service
              </a>
              .
            </p>
            <p>
              Manage your consent preferences in the{' '}
              <a id="ot-sdk-btn" class="link-underline ot-sdk-show-settings" href="#" target="_self">
                Preference Center
              </a>
              .
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default LegalDisclaimer;
